module.exports = __webpack_public_path__ + "img/symbol_9.2eb77065.png";